import { getElements, getElement, ifSelectorExist, getCookieChild } from './utils';

export const locationModal = () => {
    let modalWindow = getElement('.location-modal-window');
    let modalWindowClose = getElement('.location-modal-window--close');
    let modalWindowBtn = getElement('.location-modal-window--button');
    let modalWindowOpen = getElement('.location-modal-window--open');
    let modalWindowCitySelect = getElement('#city-select');

    // Functions
    let openModal = () => {
        modalWindow.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    let closeModal = () => {
        modalWindow.classList.add('fade-out');
        setTimeout(() => {
            modalWindow.classList.remove('open', 'fade-out');
            document.body.style.overflow = null;
        }, 300);
    }


    if (ifSelectorExist(modalWindowOpen)) {
        modalWindowOpen.addEventListener('click', () => {
            openModal();
        })
    }

    if (ifSelectorExist(modalWindow)) {
        //if (getCookieChild('selectedCity') == null & getCookieChild('selectedCity') == undefined) {
        //    openModal();
        //}

        modalWindow.addEventListener('click', (e) => {
            if (e.target === modalWindow) {
                closeModal();
            }
        });  

        window.onkeydown = (e) => {
            if (e.key === "Escape") {
                closeModal();
            }
        }
    }

    if (ifSelectorExist(modalWindowClose)) {
        modalWindowClose.addEventListener('click', () => {
            closeModal();
        })
    }

    if (ifSelectorExist(modalWindowBtn)) {
        modalWindowBtn.addEventListener('click', () => {
            closeModal();
            location.reload();
        })
    }

    if (ifSelectorExist(modalWindowCitySelect)) {
        modalWindowCitySelect.addEventListener('change', () => {
            let selectedOption = modalWindowCitySelect.options[modalWindowCitySelect.selectedIndex].text;
            modalWindowOpen.textContent = selectedOption;
        })
    }
}